import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { FormControl, FormGroup, NgControl } from '@angular/forms';

@Directive({
    selector: '[input-required]'
})
export class InputRequiredDirective {

    constructor(private elementRef: ElementRef, private control: NgControl) {
        debugger;
        if (control && control.control) {
            control.control.setValidators((c: FormControl) => {
                const v = c.value;
                if (!v || v.trim() == '') {
                    return { required: true };
                }
                return null;
            });
        }
    }

}
